<script setup lang="ts">
import { createCookieBanner } from '@lst/cookie-banner';
import { useApplicationStore } from '@/models/application-store';

import TheHeader from '@/widgets/the-header';
import TheFooter from '@/widgets/the-footer';

import ReplayDeleteDialog from '@/widgets/replay-delete-dialog';

createCookieBanner();
useApplicationStore();
</script>

<template>
  <nuxt-layout>
    <background-video />
    <div id="toast-container"></div>

    <div class="wrap">
      <common-menu />

      <the-header />
      <nuxt-page />
      <the-footer />
    </div>
    <replay-delete-dialog />
  </nuxt-layout>
</template>

<style scoped lang="postcss">
.wrap {
  display: grid;
  grid-template: auto 1fr auto / 1fr;
  height: 100dvh;
}
</style>
